export const ROUTES = {
  login: '/',
  quotes: '/quotes/:brand',
  quoteDetail: '/quotes/:brand/:id',
  brands: '/brands',
  newQuote: '/quotes/:brand/new',
  getSite(brand: string) {
    return `/quotes/${brand}`;
  },
  toQuote(brand: string, id: string) {
    return `/quotes/${brand}/${id}`;
  },
};
